<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="shadow-btm">
          <div
            class="row col-lg-6 col-sm-6 my-auto d-flex align-items-center mb-4">
            <a
              class="pr-2 text-dark cursor-pointer"
              v-on:click="$router.push('/role')"
              ><span class="font-24 mr-2"
                ><img src="/images/back-arrow.svg" width="18"
              /></span>
            </a>
            <h4 class="mb-0 lg-bld">{{ uuid ? "Edit" : "Add" }} Role</h4>
          </div>
        </div>
        <div class="page-content">
          <div class="card-body py-0 px-0">
            <div class="row">
              <div
                class="col-lg-4 col-sm-4 form-group row"
                style="margin-left: 3px">
                <label>Role Name</label>
                <input
                  type="text"
                  name="role_name"
                  class="form-control"
                  placeholder="Role Name"
                  v-model="detail.name" />
              </div>
              <div
                class="col-lg-8 col-sm-4 form-group row"
                style="margin-left: 12px">
                <label>Description</label>
                <input
                  type="text"
                  name="description"
                  class="form-control"
                  placeholder="Description"
                  v-model="detail.description" />
              </div>
            </div>
            <div class="card border mb-0 radius-15">
              <div class="card-body p-0 pb-4">
                <div class="table-responsive">
                  <div class="dataTables_wrapper dt-bootstrap4">
                    <table
                      class="table table-striped table-bordered dataTable"
                      style="width: 100%"
                      role="grid"
                      aria-describedby="example_info">
                      <thead>
                        <tr>
                          <th>Access to</th>
                          <!-- <th>All</th> -->
                          <th>View</th>

                          <th>Hide</th>
                          <th>Block</th>
                          <th>Add</th>
                          <th>Edit</th>
                          <th>Delete</th>
                          <th>Short List</th>
                          <th>Broad List</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(data, index) in detail.access" :key="index">
                          <td>{{ data.name }}</td>
                          <!-- <td><input type="checkbox"  v-model="data.is_all" true-value="1" false-value="0"/></td> -->
                          <td>
                            <input
                              type="checkbox"
                              v-model="data.is_view"
                              true-value="1"
                              false-value="0" />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              v-model="data.is_hide"
                              v-if="data.name == 'Manage Users'"
                              true-value="1"
                              false-value="0" />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              v-if="data.name == 'Manage Users'"
                              v-model="data.is_block"
                              true-value="1"
                              false-value="0" />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              v-model="data.is_add"
                              true-value="1"
                              false-value="0" />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              v-model="data.is_edit"
                              true-value="1"
                              false-value="0" />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              v-model="data.is_delete"
                              true-value="1"
                              false-value="0" />
                          </td>
                          <td>
                            <input
                              v-if="data.name == 'Manage Users'"
                              type="checkbox"
                              v-model="data.is_sl"
                              true-value="1"
                              false-value="0" />
                          </td>
                          <td>
                            <input
                              v-if="data.name == 'Manage Users'"
                              type="checkbox"
                              v-model="data.is_bl"
                              true-value="1"
                              false-value="0" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-lg-12 col-sm-12 text-center mt-2">
                    <button
                      id="save-button"
                      class="fill-btn px-4 ml-3"
                      v-on:click="save">
                      Save
                    </button>
                    <button
                      type="button"
                      class="fil-btn px-4 ml-3"
                      v-on:click="$router.go(-1)"
                      id="cancel-button">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AddRole",
  data() {
    return {
      uuid: this.$route.params.uuid,
      searchObj: {
        keyword: "",
      },
      detail: {
        name: "",
        access: [
          {
            name: "Manage Users",
            url: "member-list",
            is_all: 0,
            is_view: 0,
            is_hide: 0,
            is_block: 0,
            is_add: 0,
            is_edit: 0,
            is_delete: 0,
            is_bl: 0,
            is_sl: 0,
          },
          {
            name: "Manage Banners",
            url: "banner",
            is_all: 0,
            is_view: 0,
            is_hide: 0,
            is_block: 0,
            is_add: 0,
            is_edit: 0,
            is_delete: 0,
            is_bl: 0,
            is_sl: 0,
          },
          {
            name: "Manage Subscription Plan",
            url: "subscription-plan",
            is_all: 0,
            is_view: 0,
            is_hide: 0,
            is_block: 0,
            is_add: 0,
            is_edit: 0,
            is_delete: 0,
            is_bl: 0,
            is_sl: 0,
          },
          {
            name: "Success Stories",
            url: "success-stories",
            is_all: 0,
            is_view: 0,
            is_hide: 0,
            is_block: 0,
            is_add: 0,
            is_edit: 0,
            is_delete: 0,
            is_bl: 0,
            is_sl: 0,
          },
          {
            name: "Manage Geographical",
            url: "geographical",
            is_all: 0,
            is_view: 0,
            is_hide: 0,
            is_block: 0,
            is_add: 0,
            is_edit: 0,
            is_delete: 0,
            is_bl: 0,
            is_sl: 0,
          },
          {
            name: "Settings",
            url: "setting",
            is_all: 0,
            is_view: 0,
            is_hide: 0,
            is_block: 0,
            is_add: 0,
            is_edit: 0,
            is_delete: 0,
            is_bl: 0,
            is_sl: 0,
          },
          {
            name: "Reports",
            url: "report",
            is_all: 0,
            is_view: 0,
            is_hide: 0,
            is_block: 0,
            is_add: 0,
            is_edit: 0,
            is_delete: 0,
            is_bl: 0,
            is_sl: 0,
          },
          {
            name: "Manage staff",
            url: "admin",
            is_all: 0,
            is_view: 0,
            is_hide: 0,
            is_block: 0,
            is_add: 0,
            is_edit: 0,
            is_delete: 0,
            is_bl: 0,
            is_sl: 0,
          },
          {
            name: "Manage Dropdown Menu",
            url: "dropdown-menu",
            is_all: 0,
            is_view: 0,
            is_hide: 0,
            is_block: 0,
            is_add: 0,
            is_edit: 0,
            is_delete: 0,
            is_bl: 0,
            is_sl: 0,
          },

          {
            name: "Manage Roles",
            url: "role",
            is_all: 0,
            is_view: 0,
            is_hide: 0,
            is_block: 0,
            is_add: 0,
            is_edit: 0,
            is_delete: 0,
            is_bl: 0,
            is_sl: 0,
          },

          {
            name: "Notification",
            url: "notification",
            is_all: 0,
            is_view: 0,
            is_hide: 0,
            is_block: 0,
            is_add: 0,
            is_edit: 0,
            is_delete: 0,
            is_bl: 0,
            is_sl: 0,
          },
        ],
      },
    };
  },
  mounted() {
    this.$helperService.showMenu("true");
    console.log("uuid", this.uuid);
    if (this.uuid) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.$api
        .getAPI({
          _action: "/role/detail/" + this.uuid,
        })
        .then((res) => {
          for (var i in res.access) {
            if (res.access[i].name == "Manage Admins") {
              res.access[i].name = "Manage staff";
            }
          }
          this.detail = res;
        })
        .catch(() => {});
    },
    save() {
      if (this.uuid) {
        this.$api
          .putAPI({
            _action: "/role",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then(() => {
            this.$router.go(-1);
          })
          .catch(() => {});
      } else {
        this.$api
          .postAPI({
            _action: "/role",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then(() => {
            this.$router.go(-1);
          })
          .catch(() => {});
      }
    },
    resetFilter() {
      this.searchObj.keyword = "";
      this.getList(0);
    },
  },
};
</script>
